import { supabase } from '@/shared/lib/supabase/client';
import { AppError, unwrapMaybe } from '@/shared/lib/repository/errors';

/** Article saves (bookmarks). RLS: read/insert/delete own rows only. */
export const savesRepository = {
  async isSaved(articleId: string, userId: string): Promise<boolean> {
    const row = unwrapMaybe(
      await supabase
        .from('article_saves')
        .select('article_id')
        .eq('article_id', articleId)
        .eq('user_id', userId)
        .maybeSingle(),
    );
    return row !== null;
  },

  async save(articleId: string, userId: string): Promise<void> {
    const { error } = await supabase
      .from('article_saves')
      .insert({ article_id: articleId, user_id: userId });
    if (error) throw new AppError(error.message, error.code, error);
  },

  async unsave(articleId: string, userId: string): Promise<void> {
    const { error } = await supabase
      .from('article_saves')
      .delete()
      .eq('article_id', articleId)
      .eq('user_id', userId);
    if (error) throw new AppError(error.message, error.code, error);
  },
};
